import React, { useState, useEffect } from 'react'
import styles from './index.module.css'

import { getQueryValue } from '../../../util'

import '../../../i18n'
import { useTranslation } from 'react-i18next'

const WXModel = () => {
	const { t, i18n } = useTranslation()
	const [lang] = useState(getQueryValue('language') === 'en' ? 'en' : 'zh')
	useEffect(() => {
		i18n.changeLanguage(lang)
	}, [i18n, lang])
	return (
		<div className={styles['header-tip-wrap']}>
			<div
				className={styles['header-tip']}
				dangerouslySetInnerHTML={{ __html: t('header-tip') }}
			></div>
		</div>
	)
}

export default WXModel
